package com.veldekar.pages.spells

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.`data`.add
import com.varabyte.kobweb.core.`init`.InitRoute
import com.varabyte.kobweb.core.`init`.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.style.toModifier
import com.veldekar.components.layouts.PageLayout
import com.veldekar.components.layouts.PageLayoutData
import com.veldekar.components.srd.SpellCardContent
import com.veldekar.components.srd.spells.PolymorphDescription
import com.veldekar.components.srd.spells.PolymorphMetadata
import org.jetbrains.compose.web.css.cssRem

@InitRoute
public fun initPolymorphPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        title = "Polymorph",
        ogTitle = "Polymorph",
        ogDescription = "Tuesday's favorite spell. Turns friends into T-Rex, Giant Ape, or Giant Fruit Bat. Ludwig Voss was turned into a quokka.",
        ogImage = "images/quokkaInHandcuffs_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "Illustration of the spell Polymorph",
        includeSrdAttribution = true,
        isModal = true,
        showModalCard = false
    ))
}

@Page(routeOverride = "/spell-polymorph")
@Composable
public fun PolymorphPage() {
    val ctx = rememberPageContext()
    PageLayout(ctx) {
        Column(Modifier.fillMaxWidth().padding(2.cssRem).gap(1.cssRem)) {
            SpellCardContent(
                name = "Polymorph",
                subtitle = "4th-level Transmutation",
                veldekar = "Tuesday's favorite spell. Turns friends into T-Rex, Giant Ape, or Giant Fruit Bat. Ludwig Voss was turned into a quokka.",
                image = "images/quokkaInHandcuffs_transparent.webp",
                imageWidth = 816,
                imageHeight = 1_080,
                headerExtra = {
                    Row(Modifier.cursor(Cursor.Pointer).onClick { ctx.router.navigateTo("/spells") }, verticalAlignment = Alignment.CenterVertically) {
                        CloseIcon(Modifier.fontSize(1.5.cssRem))
                    }
                }
                ,
                metadata = { PolymorphMetadata() },
                content = { PolymorphDescription() }
            )
        }
    }
}
